(function () {
  if (window.__worthTheTripSliderBound) return;
  window.__worthTheTripSliderBound = true;

  function mountWorthTheTripSliders(root) {
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('[data-wtt-slider]').forEach(function (slider) {
      var el = slider.querySelector('.wtt-swiper');
      if (!el) return;
      if (el.swiper) el.swiper.destroy(true, true);

      var slides = el.querySelectorAll('.swiper-slide');
      if (slides.length < 2) return;

      new Swiper(el, {
        slidesPerView: 1,
        loop: false,
        speed: 450,
        spaceBetween: 0,
        pagination: {
          el: slider.querySelector('.wtt-pagination'),
          clickable: true,
        },
      });
    });
  }

  function boot() {
    mountWorthTheTripSliders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!root) return;
    mountWorthTheTripSliders(root);
  });
})();
